/**
 * Utility for collecting tracking data for Kafka integration.
 */

const TRACKING_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "gclid",
  "fbclid",
];

/**
 * Saves UTM parameters and advertising IDs from URL to sessionStorage.
 * This ensures they persist across pages during the session.
 */
export const storeTrackingParams = () => {
  if (typeof window === "undefined") return;

  const urlParams = new URLSearchParams(window.location.search);

  TRACKING_PARAMS.forEach((param) => {
    const value = urlParams.get(param);
    if (value) {
      sessionStorage.setItem(param, value);
    }
  });
};

/**
 * Reads a cookie by name.
 */
const getCookie = (name: string): string => {
  if (typeof document === "undefined") return "";

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift() || "";
  }
  return "";
};

/**
 * Collects all tracking and technical data for form submission.
 */
export const getTrackingData = () => {
  if (typeof window === "undefined") {
    return {};
  }

  const trackingData: Record<string, string> = {};

  // 1. Get UTM and Ad IDs from sessionStorage
  TRACKING_PARAMS.forEach((param) => {
    const value = sessionStorage.getItem(param);
    if (value) {
      trackingData[param] = value;
    }
  });

  // 2. Collect Cookies
  // LinkedIn: li_fat_id
  const li_fat_id = getCookie("li_fat_id");
  if (li_fat_id) {
    trackingData["li_fat_id"] = li_fat_id;
  }

  // Google Analytics: _ga (mapped to ga_client_id)
  const ga_client_id = getCookie("_ga");
  if (ga_client_id) {
    trackingData["ga_client_id"] = ga_client_id;
  }

  // 3. Technical parameters
  trackingData["landing_page"] = window.location.href;
  trackingData["referrer_url"] = document.referrer || "";

  // ip_address is left empty for backend to determine, as per instructions
  trackingData["ip_address"] = "";

  return trackingData;
};
